<div class="hail-provider-form-container" [class.read-only-mode]="isReadOnly()" role="form" aria-labelledby="form-heading">
  <p-toast></p-toast>
  <!-- ARIA Live Region for screen readers -->
  <div class="visually-hidden" role="status" aria-live="polite" aria-atomic="true">
    {{ liveRegionMessage() }}
  </div>

  <!-- Error summary: visible, focusable and announced by AT on save failure (WCAG 3.3.1) -->
  @if (formSubmitted() && !isFormValid()) {
    <div id="form-error-summary" class="border-round p-3 mb-4 border-1 border-red-400"
         role="alert" tabindex="-1" style="background:#fff0f0;">
      <p class="m-0 font-semibold" style="color:#c0392b;">
        <i class="pi pi-exclamation-circle mr-2" aria-hidden="true"></i>
        Compila tutti i campi obbligatori prima di continuare.
      </p>
    </div>
  }

  <!-- Header -->
  <div class="surface-0 border-round p-4 mb-4 shadow-1">
    <h3 id="form-heading" class="text-2xl font-bold mb-2" style="color: #00008f">Dati Specifici: Provider Grandine</h3>
    <p class="text-secondary m-0">
      Inserisci i dati specifici per il Provider Grandine. I campi contrassegnati con
      <span class="text-red-500" aria-hidden="true">*</span>
      <span class="visually-hidden">obbligatorio</span> sono obbligatori.
    </p>
  </div>

  <!-- SECTION 1: INFORMAZIONI PROVIDER GRANDINE -->
  <div class="surface-0 border-round p-4 mb-4 shadow-1" role="region" aria-labelledby="section1-heading">
    <h4 id="section1-heading" class="text-xl font-semibold mb-4" style="color: #00008f">
      <i class="pi pi-building mr-2" aria-hidden="true"></i>Sezione 1: Informazioni Provider Grandine
    </h4>
    <div class="grid mx-0">

      <!-- #1 Imprese per le quali lavora (NO) -->
      <div class="field col-12">
        <label for="companies-worked-for" class="font-semibold block mb-2">Imprese per le quali lavora</label>
        <input id="companies-worked-for" type="text" pInputText
          [(ngModel)]="companiesWorkedFor"
          placeholder="Elenco o descrizione delle imprese clienti del network"
          class="w-full" [disabled]="isReadOnly()" />
      </div>

      <!-- #2 Sinergie internazionali (SI) -->
      <div class="field col-12 md:col-4">
        <label for="synergy-international" class="font-semibold block mb-2">
          Sinergie con societa internazionali di tirabolli
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <p-inputNumber inputId="synergy-international" [(ngModel)]="synergyInternationalCompanies"
          [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 3"
          [invalid]="(formSubmitted() || touchedFields.has('synergyInternationalCompanies')) && synergyInternationalCompanies() === null"
          [attr.aria-required]="'true'"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('synergyInternationalCompanies')) && synergyInternationalCompanies() === null ? 'err-synergyInternational' : null"
          (onBlur)="markFieldAsTouched('synergyInternationalCompanies')" [disabled]="isReadOnly()" />
        @if ((formSubmitted() || touchedFields.has('synergyInternationalCompanies')) && synergyInternationalCompanies() === null) {
          <small id="err-synergyInternational" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #3 Sinergie nazionali (SI) -->
      <div class="field col-12 md:col-4">
        <label for="synergy-national" class="font-semibold block mb-2">
          Sinergie con societa nazionali di tirabolli
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <p-inputNumber inputId="synergy-national" [(ngModel)]="synergyNationalCompanies"
          [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 5"
          [invalid]="(formSubmitted() || touchedFields.has('synergyNationalCompanies')) && synergyNationalCompanies() === null"
          [attr.aria-required]="'true'"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('synergyNationalCompanies')) && synergyNationalCompanies() === null ? 'err-synergyNational' : null"
          (onBlur)="markFieldAsTouched('synergyNationalCompanies')" [disabled]="isReadOnly()" />
        @if ((formSubmitted() || touchedFields.has('synergyNationalCompanies')) && synergyNationalCompanies() === null) {
          <small id="err-synergyNational" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #4 Numero filiali (SI) -->
      <div class="field col-12 md:col-4">
        <label for="branches-count" class="font-semibold block mb-2">
          Numero Filiali
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <p-inputNumber inputId="branches-count" [(ngModel)]="numberOfBranches"
          [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 5"
          [invalid]="(formSubmitted() || touchedFields.has('numberOfBranches')) && numberOfBranches() === null"
          [attr.aria-required]="'true'"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('numberOfBranches')) && numberOfBranches() === null ? 'err-numberOfBranches' : null"
          (onBlur)="markFieldAsTouched('numberOfBranches')" [disabled]="isReadOnly()" />
        @if ((formSubmitted() || touchedFields.has('numberOfBranches')) && numberOfBranches() === null) {
          <small id="err-numberOfBranches" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #5 Tesla approved (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-isTeslaApproved">Tesla Approved <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-isTeslaApproved" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="isTeslaApproved" [value]="true" [ngModel]="isTeslaApproved()" (ngModelChange)="isTeslaApproved.set($event)" inputId="tesla-si" [disabled]="isReadOnly()" />
            <label for="tesla-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="isTeslaApproved" [value]="false" [ngModel]="isTeslaApproved()" (ngModelChange)="isTeslaApproved.set($event)" inputId="tesla-no" [disabled]="isReadOnly()" />
            <label for="tesla-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && isTeslaApproved() === null) {
          <small id="err-isTeslaApproved" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #6 Network elettrico % (SI) -->
      <div class="field col-12 md:col-4">
        <label for="electric-network-pct" class="font-semibold block mb-2">
          Network specializzato per elettrico (%)
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <p-inputNumber inputId="electric-network-pct" [(ngModel)]="electricNetworkPercentage"
          [min]="0" [max]="100" [showButtons]="false" styleClass="w-full" placeholder="Es: 25"
          suffix="%"
          [invalid]="(formSubmitted() || touchedFields.has('electricNetworkPercentage')) && electricNetworkPercentage() === null"
          [attr.aria-required]="'true'"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('electricNetworkPercentage')) && electricNetworkPercentage() === null ? 'err-electricNetworkPercentage' : null"
          (onBlur)="markFieldAsTouched('electricNetworkPercentage')" [disabled]="isReadOnly()" />
        @if ((formSubmitted() || touchedFields.has('electricNetworkPercentage')) && electricNetworkPercentage() === null) {
          <small id="err-electricNetworkPercentage" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #7 Numero carrozzerie di proprieta (SI) -->
      <div class="field col-12 md:col-4">
        <label for="owned-bodyshops-count" class="font-semibold block mb-2">
          Numero Carrozzerie di Proprieta
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <p-inputNumber inputId="owned-bodyshops-count" [(ngModel)]="numberOfOwnedBodyShops"
          [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 5"
          [invalid]="(formSubmitted() || touchedFields.has('numberOfOwnedBodyShops')) && numberOfOwnedBodyShops() === null"
          [attr.aria-required]="'true'"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('numberOfOwnedBodyShops')) && numberOfOwnedBodyShops() === null ? 'err-numberOfOwnedBodyShops' : null"
          (onBlur)="markFieldAsTouched('numberOfOwnedBodyShops')" [disabled]="isReadOnly()" />
        @if ((formSubmitted() || touchedFields.has('numberOfOwnedBodyShops')) && numberOfOwnedBodyShops() === null) {
          <small id="err-numberOfOwnedBodyShops" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #8 N. Dipendenti (SI) -->
      <div class="field col-12 md:col-4">
        <label for="employees-count" class="font-semibold block mb-2">
          N. Dipendenti (Libro Matricola)
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <p-inputNumber inputId="employees-count" [(ngModel)]="numberOfEmployees"
          [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 15"
          [invalid]="(formSubmitted() || touchedFields.has('numberOfEmployees')) && numberOfEmployees() === null"
          [attr.aria-required]="'true'"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('numberOfEmployees')) && numberOfEmployees() === null ? 'err-numberOfEmployees' : null"
          (onBlur)="markFieldAsTouched('numberOfEmployees')" [disabled]="isReadOnly()" />
        @if ((formSubmitted() || touchedFields.has('numberOfEmployees')) && numberOfEmployees() === null) {
          <small id="err-numberOfEmployees" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #9 Tirabolli dipendenti (SI) -->
      <div class="field col-12 md:col-4">
        <label for="hail-technicians" class="font-semibold block mb-2">
          Tirabolli Dipendenti
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <p-inputNumber inputId="hail-technicians" [(ngModel)]="numberOfHailTechnicians"
          [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 8"
          [invalid]="(formSubmitted() || touchedFields.has('numberOfHailTechnicians')) && numberOfHailTechnicians() === null"
          [attr.aria-required]="'true'"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('numberOfHailTechnicians')) && numberOfHailTechnicians() === null ? 'err-numberOfHailTechnicians' : null"
          (onBlur)="markFieldAsTouched('numberOfHailTechnicians')" [disabled]="isReadOnly()" />
        @if ((formSubmitted() || touchedFields.has('numberOfHailTechnicians')) && numberOfHailTechnicians() === null) {
          <small id="err-numberOfHailTechnicians" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #10 Corsi formativi (NO) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasTrainingCourses">Corsi Formativi</div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasTrainingCourses">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasTrainingCourses" [value]="true" [ngModel]="hasTrainingCourses()" (ngModelChange)="hasTrainingCourses.set($event)" inputId="has-training-si" [disabled]="isReadOnly()" />
            <label for="has-training-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasTrainingCourses" [value]="false" [ngModel]="hasTrainingCourses()" (ngModelChange)="hasTrainingCourses.set($event)" inputId="has-training-no" [disabled]="isReadOnly()" />
            <label for="has-training-no" class="cursor-pointer">No</label>
          </div>
        </div>
      </div>

      <!-- #11 Software preventivi (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasEstimateSoftware">Software Preventivi <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasEstimateSoftware" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasEstimateSoftware" [value]="true" [ngModel]="hasEstimateSoftware()" (ngModelChange)="hasEstimateSoftware.set($event)" inputId="has-estimate-si" [disabled]="isReadOnly()" />
            <label for="has-estimate-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasEstimateSoftware" [value]="false" [ngModel]="hasEstimateSoftware()" (ngModelChange)="hasEstimateSoftware.set($event)" inputId="has-estimate-no" [disabled]="isReadOnly()" />
            <label for="has-estimate-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasEstimateSoftware() === null) {
          <small id="err-hasEstimateSoftware" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #12 Centrale acquisti ricambi interna (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasInternalPartsProcurement">Centrale Acquisti Ricambi Interna <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasInternalPartsProcurement" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasInternalPartsProcurement" [value]="true" [ngModel]="hasInternalPartsProcurement()" (ngModelChange)="hasInternalPartsProcurement.set($event)" inputId="has-internal-parts-si" [disabled]="isReadOnly()" />
            <label for="has-internal-parts-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasInternalPartsProcurement" [value]="false" [ngModel]="hasInternalPartsProcurement()" (ngModelChange)="hasInternalPartsProcurement.set($event)" inputId="has-internal-parts-no" [disabled]="isReadOnly()" />
            <label for="has-internal-parts-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasInternalPartsProcurement() === null) {
          <small id="err-hasInternalPartsProcurement" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #13 Territorio operativo (SI) -->
      <div class="field col-12">
        <label for="operative-territory" class="font-semibold block mb-2">
          Territorio Operativo
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        @if (isReadOnly()) {
          <!-- In sola lettura mostriamo i territori come chip di testo: il
               p-multiselect disabilitato non rende i chip selezionati. -->
          <div id="operative-territory" class="flex flex-wrap gap-2">
            @for (label of operativeTerritoryLabels(); track label) {
              <span class="inline-flex align-items-center surface-200 text-900 border-round px-2 py-1 text-sm">{{ label }}</span>
            } @empty {
              <span class="text-600">—</span>
            }
          </div>
        } @else {
          <p-multiselect
            inputId="operative-territory"
            [options]="provinceOptions()"
            [(ngModel)]="operativeTerritory"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleziona province"
            [styleClass]="(formSubmitted() || touchedFields.has('operativeTerritory')) && operativeTerritory().length === 0 ? 'w-full p-invalid' : 'w-full'"
            [disabled]="isReadOnly()"
            [maxSelectedLabels]="provinceOptions().length"
            (onChange)="markFieldAsTouched('operativeTerritory')"
            [showToggleAll]="true"
            [filter]="true"
            filterPlaceholder="Cerca provincia..."
            [attr.aria-required]="'true'"
            [attr.aria-describedby]="(formSubmitted() || touchedFields.has('operativeTerritory')) && operativeTerritory().length === 0 ? 'err-operativeTerritory' : null"
          />
          @if ((formSubmitted() || touchedFields.has('operativeTerritory')) && operativeTerritory().length === 0) {
            <small id="err-operativeTerritory" class="text-red-700" role="alert">Campo obbligatorio</small>
          }
        }
      </div>

    </div>
  </div>

  <!-- SECTION 2: SERVIZI -->
  <div class="surface-0 border-round p-4 mb-4 shadow-1" role="region" aria-labelledby="section2-heading">
    <h4 id="section2-heading" class="text-xl font-semibold mb-4" style="color: #00008f">
      <i class="pi pi-cog mr-2" aria-hidden="true"></i>Sezione 2: Servizi
    </h4>
    <div class="grid mx-0">

      <!-- #21 Cessione di credito (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasCreditAssignment">Cessione di credito <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasCreditAssignment" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasCreditAssignment" [value]="true" [ngModel]="hasCreditAssignment()" (ngModelChange)="hasCreditAssignment.set($event)" inputId="has-credit-si" [disabled]="isReadOnly()" />
            <label for="has-credit-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasCreditAssignment" [value]="false" [ngModel]="hasCreditAssignment()" (ngModelChange)="hasCreditAssignment.set($event)" inputId="has-credit-no" [disabled]="isReadOnly()" />
            <label for="has-credit-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasCreditAssignment() === null) {
          <small id="err-hasCreditAssignment" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #22 Assorbimento minimo (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasMinimumAbsorption">Assorbimento minimo <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasMinimumAbsorption" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasMinimumAbsorption" [value]="true" [ngModel]="hasMinimumAbsorption()" (ngModelChange)="hasMinimumAbsorption.set($event)" inputId="has-min-abs-si" [disabled]="isReadOnly()" />
            <label for="has-min-abs-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasMinimumAbsorption" [value]="false" [ngModel]="hasMinimumAbsorption()" (ngModelChange)="hasMinimumAbsorption.set($event)" inputId="has-min-abs-no" [disabled]="isReadOnly()" />
            <label for="has-min-abs-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasMinimumAbsorption() === null) {
          <small id="err-hasMinimumAbsorption" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasDeductibleAbsorption">Assorbimento scoperto <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasDeductibleAbsorption" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasDeductibleAbsorption" [value]="true" [ngModel]="hasDeductibleAbsorption()" (ngModelChange)="hasDeductibleAbsorption.set($event)" inputId="has-deductible-si" [disabled]="isReadOnly()" />
            <label for="has-deductible-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasDeductibleAbsorption" [value]="false" [ngModel]="hasDeductibleAbsorption()" (ngModelChange)="hasDeductibleAbsorption.set($event)" inputId="has-deductible-no" [disabled]="isReadOnly()" />
            <label for="has-deductible-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasDeductibleAbsorption() === null) {
          <small id="err-hasDeductibleAbsorption" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #24 Riparazione prioritaria cristalli (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasPriorityGlassRepair">Riparazione prioritaria cristalli <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasPriorityGlassRepair" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasPriorityGlassRepair" [value]="true" [ngModel]="hasPriorityGlassRepair()" (ngModelChange)="hasPriorityGlassRepair.set($event)" inputId="has-priority-glass-si" [disabled]="isReadOnly()" />
            <label for="has-priority-glass-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasPriorityGlassRepair" [value]="false" [ngModel]="hasPriorityGlassRepair()" (ngModelChange)="hasPriorityGlassRepair.set($event)" inputId="has-priority-glass-no" [disabled]="isReadOnly()" />
            <label for="has-priority-glass-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasPriorityGlassRepair() === null) {
          <small id="err-hasPriorityGlassRepair" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #25 Partner riparazione cristalli (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasGlassRepairPartner">Partner per la riparazione dei cristalli <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasGlassRepairPartner" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasGlassRepairPartner" [value]="true" [ngModel]="hasGlassRepairPartner()" (ngModelChange)="hasGlassRepairPartner.set($event)" inputId="has-glass-partner-si" [disabled]="isReadOnly()" />
            <label for="has-glass-partner-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasGlassRepairPartner" [value]="false" [ngModel]="hasGlassRepairPartner()" (ngModelChange)="hasGlassRepairPartner.set($event)" inputId="has-glass-partner-no" [disabled]="isReadOnly()" />
            <label for="has-glass-partner-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasGlassRepairPartner() === null) {
          <small id="err-hasGlassRepairPartner" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #26 Ragione sociale partner cristalli - visibile e obbligatorio solo se hasGlassRepairPartner = SI -->
      @if (hasGlassRepairPartner() === true) {
        <div class="field col-12 md:col-4">
          <label for="glass-partner-name" class="font-semibold block mb-2">
            Ragione sociale partner per la riparazione dei cristalli
            <span class="text-red-500" aria-hidden="true">*</span>
            <span class="visually-hidden">obbligatorio</span>
          </label>
          <input id="glass-partner-name" type="text" pInputText
            [(ngModel)]="glassRepairPartnerName"
            placeholder="Nome del partner che si occupa della riparazione dei cristalli"
            class="w-full" [disabled]="isReadOnly()"
            aria-required="true"
            [attr.aria-invalid]="(formSubmitted() || touchedFields.has('glassRepairPartnerName')) && !glassRepairPartnerName() ? 'true' : 'false'"
            [class.p-invalid]="(formSubmitted() || touchedFields.has('glassRepairPartnerName')) && !glassRepairPartnerName()"
            [attr.aria-describedby]="(formSubmitted() || touchedFields.has('glassRepairPartnerName')) && !glassRepairPartnerName() ? 'err-glassRepairPartnerName' : null"
            (blur)="markFieldAsTouched('glassRepairPartnerName')" />
          @if ((formSubmitted() || touchedFields.has('glassRepairPartnerName')) && !glassRepairPartnerName()) {
            <small id="err-glassRepairPartnerName" class="text-red-700" role="alert">Campo obbligatorio</small>
          }
        </div>
      }

      <!-- #27 Pick up & delivery (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasPickupDelivery">Pick up &amp; delivery <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasPickupDelivery" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasPickupDelivery" [value]="true" [ngModel]="hasPickupDelivery()" (ngModelChange)="hasPickupDelivery.set($event)" inputId="has-pickup-si" [disabled]="isReadOnly()" />
            <label for="has-pickup-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasPickupDelivery" [value]="false" [ngModel]="hasPickupDelivery()" (ngModelChange)="hasPickupDelivery.set($event)" inputId="has-pickup-no" [disabled]="isReadOnly()" />
            <label for="has-pickup-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasPickupDelivery() === null) {
          <small id="err-hasPickupDelivery" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #28 Carro attrezzi (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasTowTruck">Carro attrezzi <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasTowTruck" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasTowTruck" [value]="true" [ngModel]="hasTowTruck()" (ngModelChange)="hasTowTruck.set($event)" inputId="has-tow-si" [disabled]="isReadOnly()" />
            <label for="has-tow-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasTowTruck" [value]="false" [ngModel]="hasTowTruck()" (ngModelChange)="hasTowTruck.set($event)" inputId="has-tow-no" [disabled]="isReadOnly()" />
            <label for="has-tow-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasTowTruck() === null) {
          <small id="err-hasTowTruck" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #29 Auto sostitutiva gratuita (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasFreeReplacementCar">Auto sostitutiva gratuita <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasFreeReplacementCar" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasFreeReplacementCar" [value]="true" [ngModel]="hasFreeReplacementCar()" (ngModelChange)="hasFreeReplacementCar.set($event)" inputId="has-free-car-si" [disabled]="isReadOnly()" />
            <label for="has-free-car-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasFreeReplacementCar" [value]="false" [ngModel]="hasFreeReplacementCar()" (ngModelChange)="hasFreeReplacementCar.set($event)" inputId="has-free-car-no" [disabled]="isReadOnly()" />
            <label for="has-free-car-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasFreeReplacementCar() === null) {
          <small id="err-hasFreeReplacementCar" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #30 Pulizia interna (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasInteriorCleaning">Pulizia interna <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasInteriorCleaning" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasInteriorCleaning" [value]="true" [ngModel]="hasInteriorCleaning()" (ngModelChange)="hasInteriorCleaning.set($event)" inputId="has-interior-si" [disabled]="isReadOnly()" />
            <label for="has-interior-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasInteriorCleaning" [value]="false" [ngModel]="hasInteriorCleaning()" (ngModelChange)="hasInteriorCleaning.set($event)" inputId="has-interior-no" [disabled]="isReadOnly()" />
            <label for="has-interior-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasInteriorCleaning() === null) {
          <small id="err-hasInteriorCleaning" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #31 Pulizia esterna (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasExteriorCleaning">Pulizia esterna <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasExteriorCleaning" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasExteriorCleaning" [value]="true" [ngModel]="hasExteriorCleaning()" (ngModelChange)="hasExteriorCleaning.set($event)" inputId="has-exterior-si" [disabled]="isReadOnly()" />
            <label for="has-exterior-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasExteriorCleaning" [value]="false" [ngModel]="hasExteriorCleaning()" (ngModelChange)="hasExteriorCleaning.set($event)" inputId="has-exterior-no" [disabled]="isReadOnly()" />
            <label for="has-exterior-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasExteriorCleaning() === null) {
          <small id="err-hasExteriorCleaning" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #32 Sanificazione (NO) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasSanitization">Sanificazione</div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasSanitization">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasSanitization" [value]="true" [ngModel]="hasSanitization()" (ngModelChange)="hasSanitization.set($event)" inputId="has-sanitization-si" [disabled]="isReadOnly()" />
            <label for="has-sanitization-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasSanitization" [value]="false" [ngModel]="hasSanitization()" (ngModelChange)="hasSanitization.set($event)" inputId="has-sanitization-no" [disabled]="isReadOnly()" />
            <label for="has-sanitization-no" class="cursor-pointer">No</label>
          </div>
        </div>
      </div>

      <!-- #33 Tracking per agenzie (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasRepairTrackingForAgencies">Tracking riparazione rivolto a agenzie/compagnia <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasRepairTrackingForAgencies" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasRepairTrackingForAgencies" [value]="true" [ngModel]="hasRepairTrackingForAgencies()" (ngModelChange)="hasRepairTrackingForAgencies.set($event)" inputId="has-agency-tracking-si" [disabled]="isReadOnly()" />
            <label for="has-agency-tracking-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasRepairTrackingForAgencies" [value]="false" [ngModel]="hasRepairTrackingForAgencies()" (ngModelChange)="hasRepairTrackingForAgencies.set($event)" inputId="has-agency-tracking-no" [disabled]="isReadOnly()" />
            <label for="has-agency-tracking-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasRepairTrackingForAgencies() === null) {
          <small id="err-hasRepairTrackingForAgencies" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #34 Tracking per clienti (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasRepairTrackingForClients">Tracking riparazione per i clienti <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasRepairTrackingForClients" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasRepairTrackingForClients" [value]="true" [ngModel]="hasRepairTrackingForClients()" (ngModelChange)="hasRepairTrackingForClients.set($event)" inputId="has-client-tracking-si" [disabled]="isReadOnly()" />
            <label for="has-client-tracking-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasRepairTrackingForClients" [value]="false" [ngModel]="hasRepairTrackingForClients()" (ngModelChange)="hasRepairTrackingForClients.set($event)" inputId="has-client-tracking-no" [disabled]="isReadOnly()" />
            <label for="has-client-tracking-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasRepairTrackingForClients() === null) {
          <small id="err-hasRepairTrackingForClients" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

      <!-- #35 Durata garanzia riparazioni freddo (SI) -->
      <div class="field col-12 md:col-4">
        <label for="cold-repair-warranty" class="font-semibold block mb-2">
          Durata Garanzia Riparazioni Freddo
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <input id="cold-repair-warranty" type="text" pInputText
          [(ngModel)]="coldRepairWarrantyDuration"
          placeholder="Inserire la durata della garanzia sulle riparazioni a freddo"
          class="w-full" [disabled]="isReadOnly()"
          aria-required="true"
          [attr.aria-invalid]="(formSubmitted() || touchedFields.has('coldRepairWarrantyDuration')) && !coldRepairWarrantyDuration() ? 'true' : 'false'"
          [class.p-invalid]="(formSubmitted() || touchedFields.has('coldRepairWarrantyDuration')) && !coldRepairWarrantyDuration()"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('coldRepairWarrantyDuration')) && !coldRepairWarrantyDuration() ? 'err-coldRepairWarrantyDuration' : null"
          (blur)="markFieldAsTouched('coldRepairWarrantyDuration')" />
        @if ((formSubmitted() || touchedFields.has('coldRepairWarrantyDuration')) && !coldRepairWarrantyDuration()) {
          <small id="err-coldRepairWarrantyDuration" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #36 Scanner per rilevazione danni (SI) -->
      <div class="field col-12 md:col-4">
        <label for="scanners-count" class="font-semibold block mb-2">
          Scanner per rilevazione danni
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <p-inputNumber inputId="scanners-count" [(ngModel)]="numberOfScanners"
          [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 2"
          [invalid]="(formSubmitted() || touchedFields.has('numberOfScanners')) && numberOfScanners() === null"
          [attr.aria-required]="'true'"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('numberOfScanners')) && numberOfScanners() === null ? 'err-numberOfScanners' : null"
          (onBlur)="markFieldAsTouched('numberOfScanners')" [disabled]="isReadOnly()" />
        @if ((formSubmitted() || touchedFields.has('numberOfScanners')) && numberOfScanners() === null) {
          <small id="err-numberOfScanners" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #37 Servizio a domicilio riparazioni freddo (SI) -->
      <div class="field col-12 md:col-4">
        <div class="font-semibold block mb-2" id="lbl-hasMobileRepairService">Servizio a domicilio per riparazioni a "freddo" <span class="text-red-500" aria-hidden="true">*</span><span class="visually-hidden">obbligatorio</span></div>
        <div class="flex gap-3" role="group" aria-labelledby="lbl-hasMobileRepairService" aria-required="true">
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasMobileRepairService" [value]="true" [ngModel]="hasMobileRepairService()" (ngModelChange)="hasMobileRepairService.set($event)" inputId="has-mobile-repair-si" [disabled]="isReadOnly()" />
            <label for="has-mobile-repair-si" class="cursor-pointer">Si</label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radiobutton name="hasMobileRepairService" [value]="false" [ngModel]="hasMobileRepairService()" (ngModelChange)="hasMobileRepairService.set($event)" inputId="has-mobile-repair-no" [disabled]="isReadOnly()" />
            <label for="has-mobile-repair-no" class="cursor-pointer">No</label>
          </div>
        </div>
        @if (formSubmitted() && hasMobileRepairService() === null) {
          <small id="err-hasMobileRepairService" class="text-red-700" role="alert">Seleziona un'opzione</small>
        }
      </div>

    </div>
  </div>

  <!-- SECTION 3: CONTATTI -->
  <div class="surface-0 border-round p-4 mb-4 shadow-1" role="region" aria-labelledby="section3-heading">
    <h4 id="section3-heading" class="text-xl font-semibold mb-4" style="color: #00008f">
      <i class="pi pi-phone mr-2" aria-hidden="true"></i>Sezione 3: Contatti
    </h4>
    <div class="grid mx-0">

      <!-- #38 Contatto agenzie mail (SI) -->
      <div class="field col-12 md:col-6">
        <label for="agency-email" class="font-semibold block mb-2">
          Contatto per agenzie per informazioni sui sinistri (mail)
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <input id="agency-email" type="email" pInputText [(ngModel)]="agencyContactEmail"
          placeholder="Email di contatto per agenzie"
          class="w-full" [disabled]="isReadOnly()"
          aria-required="true"
          [attr.aria-invalid]="(formSubmitted() || touchedFields.has('agencyContactEmail')) && (!agencyContactEmail() || !isValidEmail(agencyContactEmail())) ? 'true' : 'false'"
          [class.p-invalid]="(formSubmitted() || touchedFields.has('agencyContactEmail')) && (!agencyContactEmail() || !isValidEmail(agencyContactEmail()))"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('agencyContactEmail')) && !agencyContactEmail() ? 'err-agencyContactEmail-req' : (formSubmitted() || touchedFields.has('agencyContactEmail')) && agencyContactEmail() && !isValidEmail(agencyContactEmail()) ? 'err-agencyContactEmail-fmt' : null"
          (blur)="markFieldAsTouched('agencyContactEmail')" />
        @if ((formSubmitted() || touchedFields.has('agencyContactEmail')) && !agencyContactEmail()) {
          <small id="err-agencyContactEmail-req" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
        @if ((formSubmitted() || touchedFields.has('agencyContactEmail')) && agencyContactEmail() && !isValidEmail(agencyContactEmail())) {
          <small id="err-agencyContactEmail-fmt" class="text-red-700" role="alert">Formato email non valido</small>
        }
      </div>

      <!-- #39 Contatto agenzie tel (SI) -->
      <div class="field col-12 md:col-6">
        <label for="agency-phone" class="font-semibold block mb-2">
          Contatto per agenzie per informazioni sui sinistri (telefono)
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <input id="agency-phone" type="tel" pInputText [(ngModel)]="agencyContactPhone"
          placeholder="Telefono di contatto per agenzie"
          class="w-full" [disabled]="isReadOnly()"
          aria-required="true"
          [attr.aria-invalid]="(formSubmitted() || touchedFields.has('agencyContactPhone')) && !agencyContactPhone() ? 'true' : 'false'"
          [class.p-invalid]="(formSubmitted() || touchedFields.has('agencyContactPhone')) && !agencyContactPhone()"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('agencyContactPhone')) && !agencyContactPhone() ? 'err-agencyContactPhone' : null"
          (blur)="markFieldAsTouched('agencyContactPhone')" />
        @if ((formSubmitted() || touchedFields.has('agencyContactPhone')) && !agencyContactPhone()) {
          <small id="err-agencyContactPhone" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #40 Contatto direzione mail (SI) -->
      <div class="field col-12 md:col-6">
        <label for="management-email" class="font-semibold block mb-2">
          Contatto per direzione per informazioni sui sinistri (mail)
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <input id="management-email" type="email" pInputText [(ngModel)]="managementContactEmail"
          placeholder="Email di contatto per la direzione"
          class="w-full" [disabled]="isReadOnly()"
          aria-required="true"
          [attr.aria-invalid]="(formSubmitted() || touchedFields.has('managementContactEmail')) && (!managementContactEmail() || !isValidEmail(managementContactEmail())) ? 'true' : 'false'"
          [class.p-invalid]="(formSubmitted() || touchedFields.has('managementContactEmail')) && (!managementContactEmail() || !isValidEmail(managementContactEmail()))"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('managementContactEmail')) && !managementContactEmail() ? 'err-managementContactEmail-req' : (formSubmitted() || touchedFields.has('managementContactEmail')) && managementContactEmail() && !isValidEmail(managementContactEmail()) ? 'err-managementContactEmail-fmt' : null"
          (blur)="markFieldAsTouched('managementContactEmail')" />
        @if ((formSubmitted() || touchedFields.has('managementContactEmail')) && !managementContactEmail()) {
          <small id="err-managementContactEmail-req" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
        @if ((formSubmitted() || touchedFields.has('managementContactEmail')) && managementContactEmail() && !isValidEmail(managementContactEmail())) {
          <small id="err-managementContactEmail-fmt" class="text-red-700" role="alert">Formato email non valido</small>
        }
      </div>

      <!-- #41 Contatto direzione tel (SI) -->
      <div class="field col-12 md:col-6">
        <label for="management-phone" class="font-semibold block mb-2">
          Contatto per direzione per informazioni sui sinistri (telefono)
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <input id="management-phone" type="tel" pInputText [(ngModel)]="managementContactPhone"
          placeholder="Telefono di contatto per la direzione"
          class="w-full" [disabled]="isReadOnly()"
          aria-required="true"
          [attr.aria-invalid]="(formSubmitted() || touchedFields.has('managementContactPhone')) && !managementContactPhone() ? 'true' : 'false'"
          [class.p-invalid]="(formSubmitted() || touchedFields.has('managementContactPhone')) && !managementContactPhone()"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('managementContactPhone')) && !managementContactPhone() ? 'err-managementContactPhone' : null"
          (blur)="markFieldAsTouched('managementContactPhone')" />
        @if ((formSubmitted() || touchedFields.has('managementContactPhone')) && !managementContactPhone()) {
          <small id="err-managementContactPhone" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #42 Contatto studi peritali mail (SI) -->
      <div class="field col-12 md:col-6">
        <label for="expert-email" class="font-semibold block mb-2">
          Contatto per studi peritali AXA (mail)
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <input id="expert-email" type="email" pInputText [(ngModel)]="surveyOfficeContactEmail"
          placeholder="Email di contatto per studi peritali"
          class="w-full" [disabled]="isReadOnly()"
          aria-required="true"
          [attr.aria-invalid]="(formSubmitted() || touchedFields.has('surveyOfficeContactEmail')) && (!surveyOfficeContactEmail() || !isValidEmail(surveyOfficeContactEmail())) ? 'true' : 'false'"
          [class.p-invalid]="(formSubmitted() || touchedFields.has('surveyOfficeContactEmail')) && (!surveyOfficeContactEmail() || !isValidEmail(surveyOfficeContactEmail()))"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('surveyOfficeContactEmail')) && !surveyOfficeContactEmail() ? 'err-surveyOfficeContactEmail-req' : (formSubmitted() || touchedFields.has('surveyOfficeContactEmail')) && surveyOfficeContactEmail() && !isValidEmail(surveyOfficeContactEmail()) ? 'err-surveyOfficeContactEmail-fmt' : null"
          (blur)="markFieldAsTouched('surveyOfficeContactEmail')" />
        @if ((formSubmitted() || touchedFields.has('surveyOfficeContactEmail')) && !surveyOfficeContactEmail()) {
          <small id="err-surveyOfficeContactEmail-req" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
        @if ((formSubmitted() || touchedFields.has('surveyOfficeContactEmail')) && surveyOfficeContactEmail() && !isValidEmail(surveyOfficeContactEmail())) {
          <small id="err-surveyOfficeContactEmail-fmt" class="text-red-700" role="alert">Formato email non valido</small>
        }
      </div>

      <!-- #43 Contatto studi peritali tel (SI) -->
      <div class="field col-12 md:col-6">
        <label for="expert-phone" class="font-semibold block mb-2">
          Contatto per studi peritali AXA (telefono)
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <input id="expert-phone" type="tel" pInputText [(ngModel)]="surveyOfficeContactPhone"
          placeholder="Telefono di contatto per studi peritali"
          class="w-full" [disabled]="isReadOnly()"
          aria-required="true"
          [attr.aria-invalid]="(formSubmitted() || touchedFields.has('surveyOfficeContactPhone')) && !surveyOfficeContactPhone() ? 'true' : 'false'"
          [class.p-invalid]="(formSubmitted() || touchedFields.has('surveyOfficeContactPhone')) && !surveyOfficeContactPhone()"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('surveyOfficeContactPhone')) && !surveyOfficeContactPhone() ? 'err-surveyOfficeContactPhone' : null"
          (blur)="markFieldAsTouched('surveyOfficeContactPhone')" />
        @if ((formSubmitted() || touchedFields.has('surveyOfficeContactPhone')) && !surveyOfficeContactPhone()) {
          <small id="err-surveyOfficeContactPhone" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- #44 Mail soggetti terzi (SI) -->
      <div class="field col-12 md:col-6">
        <label for="third-party-email" class="font-semibold block mb-2">
          Mail da comunicare a soggetti terzi per iniziative commerciali
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <input id="third-party-email" type="email" pInputText [(ngModel)]="thirdPartyCommercialEmail"
          placeholder="Email da utilizzare per comunicazioni a soggetti terzi"
          class="w-full" [disabled]="isReadOnly()"
          aria-required="true"
          [attr.aria-invalid]="(formSubmitted() || touchedFields.has('thirdPartyCommercialEmail')) && (!thirdPartyCommercialEmail() || !isValidEmail(thirdPartyCommercialEmail())) ? 'true' : 'false'"
          [class.p-invalid]="(formSubmitted() || touchedFields.has('thirdPartyCommercialEmail')) && (!thirdPartyCommercialEmail() || !isValidEmail(thirdPartyCommercialEmail()))"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('thirdPartyCommercialEmail')) && !thirdPartyCommercialEmail() ? 'err-thirdPartyCommercialEmail-req' : (formSubmitted() || touchedFields.has('thirdPartyCommercialEmail')) && thirdPartyCommercialEmail() && !isValidEmail(thirdPartyCommercialEmail()) ? 'err-thirdPartyCommercialEmail-fmt' : null"
          (blur)="markFieldAsTouched('thirdPartyCommercialEmail')" />
        @if ((formSubmitted() || touchedFields.has('thirdPartyCommercialEmail')) && !thirdPartyCommercialEmail()) {
          <small id="err-thirdPartyCommercialEmail-req" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
        @if ((formSubmitted() || touchedFields.has('thirdPartyCommercialEmail')) && thirdPartyCommercialEmail() && !isValidEmail(thirdPartyCommercialEmail())) {
          <small id="err-thirdPartyCommercialEmail-fmt" class="text-red-700" role="alert">Formato email non valido</small>
        }
      </div>

      <!-- #45 Mail notifica incarico sinistro (SI) -->
      <div class="field col-12 md:col-6">
        <label for="claim-notification-email" class="font-semibold block mb-2">
          Mail per ricezione notifica incarico sinistro
          <span class="text-red-500" aria-hidden="true">*</span>
          <span class="visually-hidden">obbligatorio</span>
        </label>
        <input id="claim-notification-email" type="email" pInputText [(ngModel)]="claimAssignmentNotificationEmail"
          placeholder="Email da utilizzare per ricezione di un nuovo incarico (gestione sinistro)"
          class="w-full" [disabled]="isReadOnly()"
          aria-required="true"
          [attr.aria-invalid]="(formSubmitted() || touchedFields.has('claimAssignmentNotificationEmail')) && (!claimAssignmentNotificationEmail() || !isValidEmail(claimAssignmentNotificationEmail())) ? 'true' : 'false'"
          [class.p-invalid]="(formSubmitted() || touchedFields.has('claimAssignmentNotificationEmail')) && (!claimAssignmentNotificationEmail() || !isValidEmail(claimAssignmentNotificationEmail()))"
          [attr.aria-describedby]="(formSubmitted() || touchedFields.has('claimAssignmentNotificationEmail')) && !claimAssignmentNotificationEmail() ? 'err-claimAssignmentNotificationEmail-req' : (formSubmitted() || touchedFields.has('claimAssignmentNotificationEmail')) && claimAssignmentNotificationEmail() && !isValidEmail(claimAssignmentNotificationEmail()) ? 'err-claimAssignmentNotificationEmail-fmt' : null"
          (blur)="markFieldAsTouched('claimAssignmentNotificationEmail')" />
        @if ((formSubmitted() || touchedFields.has('claimAssignmentNotificationEmail')) && !claimAssignmentNotificationEmail()) {
          <small id="err-claimAssignmentNotificationEmail-req" class="text-red-700" role="alert">Campo obbligatorio</small>
        }
        @if ((formSubmitted() || touchedFields.has('claimAssignmentNotificationEmail')) && claimAssignmentNotificationEmail() && !isValidEmail(claimAssignmentNotificationEmail())) {
          <small id="err-claimAssignmentNotificationEmail-fmt" class="text-red-700" role="alert">Formato email non valido</small>
        }
      </div>

    </div>
  </div>

  <!-- SEZIONE COLLABORATORI rimossa: i collaboratori sono ora gestiti nello step
       unificato "Impiegati Amministrativi e Collaboratori". -->

  <!-- Footer con pulsanti -->
  <div class="surface-0 border-round p-4 shadow-1">
    <div class="flex flex-wrap gap-3 justify-content-end">
      <button type="button" pButton label="Salva Bozza" icon="pi pi-save"
        class="p-button-outlined" (click)="saveDraft()" [disabled]="isSaving()"
        [attr.aria-label]="'Salva i dati in bozza senza validazione'"></button>
      <button type="button" pButton label="Salva e continua" icon="pi pi-arrow-right"
        iconPos="right" (click)="saveAndProceed()" [disabled]="isSaving()" [loading]="isSaving()"
        [attr.aria-label]="'Valida e salva i dati, poi procedi allo step successivo'"></button>
    </div>
  </div>
</div>
